<template>
  <!-- 招募详情 -->
  <div class="g-content">
    <div class="page-activity-detail">
      <div class="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            :to="{ path: '/volunteer/recruit',query:{serviceType: serviceType} }">{{serviceType == 2 ? '接待讲解' : serviceType == 3 ? '社会教育活动' : '临展讲解'}}招募</el-breadcrumb-item>
          <el-breadcrumb-item>活动状态 - {{detailData.activeStatus | filterStatus(that)}} </el-breadcrumb-item>
        </el-breadcrumb>
        <a class="to-back" @click="goBack">
          <i class="el-icon-back"></i>&nbsp;&nbsp;返回
        </a>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <el-row class="head-info" v-if="serviceType  == 2">
          <el-col :span="6" class="pic-box">
            <img :src="detailData.mainPic" alt>
          </el-col>
          <el-col :span="18">
            <el-col :span="4" class="label tr">讲解名称</el-col>
            <el-col :span="8" class="name">{{detailData.serviceName}}</el-col>

            <el-col :span="4" class="label tr">展览名称</el-col>
            <el-col :span="8" class="name">{{detailData.exhibitionName}}</el-col>

            <el-col :span="4" class="label tr">展厅位置</el-col>
            <el-col :span="8" class="name">{{detailData.serviceLocation}}</el-col>

            <el-col :span="4" class="label tr">服务时间</el-col>
            <el-col :span="8" class="name">{{detailData.serviceTimeBegin}}～{{detailData.serviceTimeEnd}}</el-col>

            <el-col :span="4" class="label tr">讲解时长</el-col>
            <el-col :span="8" class="name">{{detailData.serviceDuration || 0}}</el-col>

            <el-col :span="4" class="label tr">讲解场次</el-col>
            <el-col :span="8" class="name">{{detailData.explainNum || 0}}</el-col>

            <el-col :span="4" class="label tr">招募名额</el-col>
            <el-col :span="8" class="name">{{detailData.quota || 0}}</el-col>

            <el-col :span="4" class="label tr">已报名</el-col>
            <el-col :span="8" class="name">{{detailData.quotaAlready ? detailData.quotaAlready : 0}}</el-col>

            <el-col :span="4" class="label tr">取消报名</el-col>
            <el-col :span="8"
              class="name">{{detailData.cancelRegistration ? detailData.cancelRegistration : 0}}</el-col>

            <el-col :span="4" class="label tr">报名截止</el-col>
            <el-col :span="8" class="name">{{detailData.deadlineTime}}</el-col>

          </el-col>

          <!-- <el-row class="box-flex" style="display:flex;">
            <div class="label tr">服务内容</div>
            <div class="name">{{detailData.content}}</div>

            <div class="label tr">报名截止</div>
            <div class="name">{{detailData.deadlineTime}}</div>
          </el-row> -->
        </el-row>

        <el-row class="head-info" v-else-if="serviceType  == 3">
          <el-col :span="6" class="pic-box">
            <img :src="detailData.mainPic" alt>
          </el-col>
          <el-col :span="18">
            <el-col :span="4" class="label tr">活动名称</el-col>
            <el-col :span="8" class="name">{{detailData.exhibitionName}}</el-col>

            <el-col :span="4" class="label tr">活动地点</el-col>
            <el-col :span="8" class="name">{{detailData.serviceLocation}}</el-col>

            <el-col :span="4" class="label tr">活动内容</el-col>
            <el-col :span="8" class="name">{{detailData.content || ""}}</el-col>

            <el-col :span="4" class="label tr">服务时间</el-col>
            <el-col :span="8" class="name">{{detailData.serviceTimeBegin}}～{{detailData.serviceTimeEnd}}</el-col>

            <el-col :span="4" class="label tr">活动时长</el-col>
            <el-col :span="8" class="name">{{detailData.serviceDuration || 0}}</el-col>

            <el-col :span="4" class="label tr">折合讲解场次</el-col>
            <el-col :span="8" class="name">{{detailData.explainNum || 0}}</el-col>

            <el-col :span="4" class="label tr">招募名额</el-col>
            <el-col :span="8" class="name">{{detailData.quota || 0}}</el-col>

            <el-col :span="4" class="label tr">已报名</el-col>
            <el-col :span="8" class="name">{{detailData.quotaAlready ? detailData.quotaAlready : 0}}</el-col>

            <el-col :span="4" class="label tr">取消报名</el-col>
            <el-col :span="8"
              class="name">{{detailData.cancelRegistration ? detailData.cancelRegistration : 0}}</el-col>

            <el-col :span="4" class="label tr">报名截止</el-col>
            <el-col :span="8" class="name">{{detailData.deadlineTime}}</el-col>

          </el-col>
        </el-row>

        <el-row class="head-info" v-else>
          <el-col :span="6" class="pic-box" style="height: 164px">
            <img :src="detailData.mainPic" alt>
          </el-col>
          <el-col :span="18">
            <el-col :span="4" class="label tr">展览名称</el-col>
            <el-col :span="8" class="name">{{detailData.exhibitionName}}</el-col>

            <el-col :span="4" class="label tr">展厅位置</el-col>
            <el-col :span="8" class="name">{{detailData.serviceLocation}}</el-col>

            <el-col :span="4" class="label tr">服务时间</el-col>
            <el-col :span="8" class="name">{{detailData.serviceTimeBegin}}～{{detailData.serviceTimeEnd}}</el-col>

            <el-col :span="4" class="label tr">招募名额</el-col>
            <el-col :span="8" class="name">{{detailData.quota || 0}}</el-col>

            <el-col :span="4" class="label tr">已报名</el-col>
            <el-col :span="8" class="name">{{detailData.quotaAlready ? detailData.quotaAlready : 0}}</el-col>

            <el-col :span="4" class="label tr">取消报名</el-col>
            <el-col :span="8"
              class="name">{{detailData.cancelRegistration ? detailData.cancelRegistration : 0}}</el-col>

            <el-col :span="4" class="label tr">要求场次</el-col>
            <el-col :span="8" class="name">{{detailData.explainNum || 0}}</el-col>

            <el-col :span="4" class="label tr">报名截止</el-col>
            <el-col :span="8" class="name">{{detailData.deadlineTime}}</el-col>

          </el-col>
        </el-row>

        <div class="con mt-20">
          <h2 class="title clearfix">
            <span>招募状态：{{detailData.status | filterVolunteerRecruitStatus(that)}} </span>
          </h2>

          <!-- 报名列表 -->
          <div class="box box-signup">
            <p class="tit">报名列表</p>
            <!-- 表格 -->
            <div class="table">
              <!-- 报名中 -->
              <el-table stripe :data="tableData">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">{{ scope.$index+1 }}</template>
                </el-table-column>
                <el-table-column label="报名时间" min-width="12%">
                  <template slot-scope="scope">{{ scope.row.enrollTime | DateFormat('yyyy-MM-dd')}}</template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="10%"></el-table-column>
                <el-table-column prop="sex" label="性别" min-width="6%">
                  <template slot-scope="scope">{{ scope.row.sex == '1' ? '男': (scope.row.sex == '0' ? '女': '') }}</template>

                </el-table-column>
                <el-table-column prop="age" label="年龄" min-width="6%"></el-table-column>
                <el-table-column prop="phone" label="手机" min-width="15%"></el-table-column>
                <el-table-column label="志愿者状态" min-width="9%">
                  <template slot-scope="scope">{{ scope.row.volunteerStatus | filterVolunteerStatus }}</template>
                </el-table-column>
                <el-table-column prop="cancellationTimes" label="累计取消报名次数" min-width="15%"></el-table-column>

                <el-table-column v-if="serviceType != 4" prop="status" label="服务状态" min-width="12%">
                  <template slot-scope="scope">{{ scope.row.status == 0 ? '待服务':'已服务' }}</template>
                </el-table-column>

                <el-table-column v-if="serviceType == 4" prop="enrollTime" label="报名时间" min-width="16%">
                </el-table-column>

                <el-table-column v-if="serviceType == 4" prop="enrollStatus" label="报名状态" min-width="12%">
                  <template slot-scope="scope">{{ scope.row.enrollStatus | filterEnrollStatus }}</template>
                </el-table-column>

                <el-table-column v-if="serviceType == 2" label="讲解时长" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.serviceTime || 0 }}小时</template>
                </el-table-column>
                <el-table-column v-if="serviceType == 2" label="讲解场次" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.serviceNum }}</template>
                </el-table-column>

                <el-table-column v-if="serviceType == 3" label="活动时长" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.serviceTime || 0 }}小时</template>
                </el-table-column>
                <el-table-column v-if="serviceType == 3" label="折合讲解场次" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.serviceNum }}</template>
                </el-table-column>

                <el-table-column v-if="serviceType == 4" label="总时长" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.totalServiceTime || 0 }}小时</template>
                </el-table-column>
                <el-table-column v-if="serviceType == 4" label="总场次" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.totalServiceNum }}</template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" min-width="18%">
                  <template slot-scope="scope">
                    <!-- <a class="m-btn mr-10" v-if="detailData.status == 1" @click="handleOperate(scope.row)">取消报名</a> -->
                    <!-- && (scope.row.serviceNum==''|| scope.row.serviceNum==null) && (scope.row.serviceTime==''|| scope.row.serviceTime==null) -->
                    <a class="m-btn mr-10" v-if="serviceType != '4' && detailData.status == 3 && scope.row.status == 0 "
                      @click="serviceApproved(scope.row)">服务核定</a>
                      <!-- detailData.activeStatus == 0  &&  -->
                    <span v-else-if="serviceType == '4'">
                      <a class="m-btn mr-10" @click="tempExhibitionPass(scope.row)">通过</a>
                      <a class="m-btn mr-10 m-danger" @click="tempExhibitionNotPass(scope.row)">不通过</a>
                    </span>
                    <a class="m-btn mr-10" v-else>-</a>

                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 服务现场图片 -->
          <!-- <div class="box box-site">
            <p class="tit">服务现场图片</p>
            <div>
              <cmp-upload style="width: 100%;" :callFun="uploadCallback" :fileList="remoteFileList" :businessType="`recruit`" :accept="`image/*`" :multipleType="true" :showName="false" :showTip="false" :txt="`上传`" :isPicDiff="true" imgWidth="120px" imgHeight="80px"></cmp-upload>
            </div>

            <el-row :gutter="10" class="list" v-viewer>
              <el-col :span="4" class="item" v-for="(item, index) in detailData.scenePicturesList" :key="index">
                <img class="g-pointer" :src="item.url" alt>
              </el-col>
            </el-row>
          </div> -->
        </div>
      </div>
    </div>

    <dialogAddSignup ref="dialogAddSignup" @refresh="refreshDetail"></dialogAddSignup>
    <dialogEvalute ref="dialogEvalute" @refresh="refreshDetail"></dialogEvalute>
  </div>
</template>

<script>
import cmpUpload from '@cmp/my-upload/index' //上传组件
import dialogAddSignup from './dialog-add-signup'
import dialogEvalute from './dialog-evaluate'
export default {
  components: {
    cmpUpload,
    dialogAddSignup,
    dialogEvalute
  },
  data() {
    return {
      that: this,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      detailData: {},
      serviceType: '',
      statusList: [{ dictCode: 0, dictName: '活动未开始' }, { dictCode: 1, dictName: '活动已开始' }, { dictCode: 2, dictName: '活动已结束' }, { dictCode: 3, dictName: '活动已废弃' }],
      tableData: [],
      volunteerRecruitList: [],
      listQuery: {
        currentPage: 1,
        size: 5
      },
      total: 0,
      commentList: [],
      listQuery2: {
        currentPage: 1,
        size: 5
      },
      total2: 0,
      remoteFileList: []
    }
  },
  filters: {
    filterStatus(type, self) {

      let obj = self.statusList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterVolunteerRecruitStatus(type, self) {

      let obj = self.volunteerRecruitList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterVolunteerStatus(status) {
      if (status == 1) {
        return '预备志愿者'
      } else if (status == 2) {
        return '正式志愿者'
      } else if (status == 3) {
        return '小志愿者'
      } else if (status == 4) {
        return '学生志愿者'

      }

      return null
    },
    filterEnrollStatus(status){
      if (status == 0) {
        return '取消报名'
      } else if (status == 1) {
        return '报名中'
      } else if (status == 2) {
        return '通过'
      } else if (status == 3) {
        return '未通过'
      }
    },
    filterServiceStatus(status) {
      if (status == 1) {
        return '已服务'
      } else if (status == 0) {
        return '待服务'
      }

      return null
    },

  },
  methods: {
    getDetailData() {
      this.$api.volunteer.getVolunteerRecruitDetail({
        id: this.$route.query.id
      }).then(res => {
        if (res.success) {
          let data = res.result
          this.detailData = data.recruit
          this.tableData = data.recruitUser
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // // 报名列表
    // getDataList() {
    //   this.listLoading = true
    //   this.$http
    //     .get('/BsVolunteerRecruitUser/pageList', {
    //       ...this.listQuery,
    //       recruitId: this.$route.query.id, // 服务项目ID
    //       userId: ''
    //     })
    //     .then(res => {
    //       this.listLoading = false
    //       if (res.success) {
    //         this.tableData = res.result
    //         this.total = res.page.allRow
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },
    // // 评论
    // getCommentList() {
    //   this.$http
    //     .get('/user/listApproval', {
    //       ...this.listQuery2
    //     })
    //     .then(res => {
    //       if (res.success) {
    //         this.commentList = res.result
    //         this.total2 = res.page.allRow
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },

    tempExhibitionPass(obj) {
      this.$common.confirm(
        {
          title: '服务确认',
          content: '是否通过？'
        }, () => {
          this.$api.volunteer.pass({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('设置成功')
              this.getDetailData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    tempExhibitionNotPass(obj) {
      this.$common.confirm(
        {
          title: '服务确认',
          content: '是否不通过？'
        }, () => {
          this.$api.volunteer.notPass({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('设置成功')
              this.getDetailData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },
    uploadCallback(ids) {
      this.$http
        .post('/BsVolunteerRecruit/updatePicture', {
          id: this.$route.query.id,
          scenePictures: ids
        })
        .then(res => {
          if (res.success) {
            this.getDetailData()
            // this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    refreshDetail() {
      this.getDetailData()
    },
    // 重置查询
    restList() {
      this.listQuery.currentPage = 1
    },
    handleAdd() {
      this.$refs.dialogAddSignup.init()
    },
    handleExport() {
      location.href =
        '/singleMuseum/bsActivity/exportData?key=' + this.$route.query.id
    },
    // 评价
    serviceApproved(item) {
      this.$refs.dialogEvalute.init(item, this.serviceType)
    },
    handleOperate(item) {
      this.$http
        .post('/BsVolunteerRecruitUser/cancelEnroll', {
          id: item.id // 报名ID
        })
        .then(res => {
          if (res.success) {
            this.$message.success('取消报名成功')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 拉黑/解冻
    // handleStatus(item) {
    //   let str = item.userDataState === '1' ? '拉黑' : '解冻'
    //   this.$common.confirm(
    //     {
    //       title: '您正在' + str + '用户，是否确认' + str + '？',
    //       className: 'cus-confirm-375'
    //     },
    //     () => {
    //       this.$http
    //         .put('/bsPubUser/removeBlack', {
    //           id: item.userId,
    //           type: item.userDataState === '1' ? '2' : '1' // 1-移出 2-移入
    //         })
    //         .then(res => {
    //           if (res.success) {
    //             this.$message.success(str + '成功')
    //             this.getDataList()
    //           } else {
    //             this.$message.error(res.message)
    //           }
    //         })
    //     }
    //   )
    // },
    goBack() {
      this.$router.push({ path: '/volunteer/recruit', query: { serviceType: this.serviceType } })
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      // this.getDataList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      // this.getDataList()
    },
    handleSizeChange2(val) {
      this.listQuery2.size = val
      this.getCommentList()
    },
    // 点击序号
    handleCurrentChange2(val) {
      this.listQuery2.currentPage = val
      this.getCommentList()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_recruit_status']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            this.volunteerRecruitList = state['volunteer_recruit_status']

          }
        })
    },

  },
  created() {
    this.getDropdownValue()
    this.getDetailData()
    this.serviceType = this.$route.query.serviceType
    // this.getDataList()
    // this.getCommentList()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-detail {
  .header {
    position: relative;
    .el-breadcrumb {
      font-size: 18px;
      /deep/.el-breadcrumb__inner {
        font-weight: bold;
        color: rgba(87, 89, 98, 1);
      }
      /deep/.el-breadcrumb__inner.is-link,
      .el-breadcrumb__inner a {
        color: #9699a2;
      }
    }
    .to-back {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      color: #9699a2;
    }
  }
  .content {
    font-size: 14px;
    .head-info {
      font-size: 14px;
      // line-height: 40px;
      border: solid 1px $border;
      border-bottom: none;
      border-right: none;
      .pic-box {
        padding: 10px;
        box-sizing: border-box;
        height: 205px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        display: flex;
        img {
          max-width: 100%;
          max-height: 100%;
          margin: auto;
          display: block;
        }
      }
      .label,
      .name {
        padding: 5px 20px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        display: flex;
        align-items: center;
        // height: 40px;
        box-sizing: border-box;
        height: 41px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .label {
        background: #fcfcfe;
      }

      .box-flex {
        .label {
          box-sizing: border-box;
          width: 16.66667%;
        }
        .name {
          box-sizing: border-box;
          width: 33.33333%;
        }
      }
    }

    .con {
      border: solid 1px $border;
      h2.title {
        padding: 0 20px;
        line-height: 60px;
        border-bottom: solid 1px $border;
        color: $danger;
      }
      .box {
        padding: 10px 20px;
        .tit {
          padding: 10px 0;
        }
      }
      .box-site {
        .list {
          margin-top: 20px;
          .item {
            text-align: center;
            padding: 0 10px;
            margin-bottom: 10px;
            img {
              width: 200px;
              height: 150px;
              object-fit: cover;
            }
          }
        }
      }
    }

    .my-table-item.list {
      .label {
        border-bottom: solid 1px $border;
      }
      .txt {
        padding: 0;
      }
    }
  }
  .my-table {
    display: inline-block;
    width: 100%;

    .my-table-item {
      display: flex;
      justify-content: space-around;
      line-height: 30px;
      border: solid 1px $border;
      border-bottom: none;
      text-align: center;
      font-size: 14px;
      .txt {
        padding: 0 5px;
        border-left: solid 1px $border;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>


